var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import MdsDataplaneResource from "./MdsDataplaneResource.js";
import experimentResource from "./ExperimentReadV2Resource.js";
import * as _ from "lodash";
import { AnalysisUtilsInstance } from "../utils/AnalysisUtils.js";
import MasterDataConstants from "../constants/FeatureDataConstants.js";
import { getExperimentationGroupIdFromPath } from "../utils/ManagementGroup/ManagementGroup.utils.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AnalysisResource = class extends RestServiceBase {
  constructor() {
    const apiPath = "/api/analysis/";
    super(EnvironmentService.endpoints.legacy, apiPath);
  }
  getAnalysisPlan(rolloutId) {
    return __async(this, null, function* () {
      const rolloutRootStepId = yield experimentResource.getRolloutRootStepId(rolloutId);
      const analysisPlan = yield this.getAnalysisPlanInternal(rolloutRootStepId);
      return analysisPlan;
    });
  }
  getAvailableTemplates(workspaceId, managementGroup) {
    return __async(this, null, function* () {
      var _a;
      const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
      const analysisConfig = yield MdsDataplaneResource.getConfigWithType({
        workspaceId,
        experimentationGroup,
        section: MasterDataConstants.analysisConfigSection
      });
      if (analysisConfig.OptInAnalysisTemplates) {
        return (_a = analysisConfig.OptInAnalysisTemplates.Templates) != null ? _a : [];
      } else {
        return _.chain(analysisConfig.AnalysisRules).map((r) => r.SelectedAnalysisTemplates).reduce((a, b) => a.concat(b)).uniqWith((a, b) => {
          return a.toLowerCase() === b.toLowerCase();
        }).value();
      }
    });
  }
  getAllTemplates() {
    return __async(this, null, function* () {
      const address = "templates";
      const result = yield this._get(address);
      const allTemplateNames = result.getSuccessData().map((t) => t.Name);
      return allTemplateNames;
    });
  }
  getAnalysisRequest(stepId, scorecardId) {
    return __async(this, null, function* () {
      const address = `/request?experimentStepId=${stepId}&scorecardId=${scorecardId}`;
      const result = yield this._get(address);
      const analysisRequest = result.getSuccessData();
      return analysisRequest;
    });
  }
  getSegments(metricSet, metricSetVersion) {
    return __async(this, null, function* () {
      let address = `/metricSets/${encodeURIComponent(metricSet)}/segments`;
      if (metricSetVersion && metricSetVersion.length > 0) {
        address = `${address}/?metricSetVersion=${metricSetVersion}`;
      }
      const result = yield this._get(address);
      if (result.statusCode === 500 || result.getSuccessData() === null) {
        return void 0;
      }
      return result.getSuccessData();
    });
  }
  getFilterMapping(metricSet, fromFilter) {
    return __async(this, null, function* () {
      const address = `/metricSets/${encodeURIComponent(metricSet)}/trafficFilterDimensionMaps/${fromFilter}`;
      const result = yield this._get(address);
      if (result.statusCode === 404) {
        return void 0;
      }
      return result.getSuccessData();
    });
  }
  createAnalysis(request) {
    return __async(this, null, function* () {
      const address = `create`;
      return yield this._post(request, address);
    });
  }
  saveAnalysisPlan(analysisGroups, rolloutId, workspaceId) {
    return __async(this, null, function* () {
      const rolloutRootStepId = yield experimentResource.getRolloutRootStepId(rolloutId);
      const createPromise = this.createNewAnalysisGroups(analysisGroups, rolloutRootStepId, workspaceId);
      yield this.removeAnalysisGroups(analysisGroups);
      yield createPromise;
      return yield this.getAnalysisPlanInternal(rolloutRootStepId);
    });
  }
  validateAnalysisGroup(analysisGroupInEditor) {
    return __async(this, null, function* () {
      const address = `validateTriggerExpression`;
      const validationRequest = {
        TemplateName: analysisGroupInEditor.analysisGroup.selectedTemplates[0],
        TriggerExpression: analysisGroupInEditor.analysisGroup.triggerExpression
      };
      const promise = yield this._post(
        validationRequest,
        address
      );
      const forayValidationResponse = promise.getSuccessData();
      if (forayValidationResponse.IsValid === false) {
        analysisGroupInEditor.validationError = forayValidationResponse.ErrorMessage;
      }
      return analysisGroupInEditor;
    });
  }
  getEnableCustomScorecardCreationInRollouts(workspaceId, managementGroup) {
    return __async(this, null, function* () {
      const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
      const analysisConfig = yield MdsDataplaneResource.getConfigWithType({
        workspaceId,
        experimentationGroup,
        section: MasterDataConstants.analysisConfigSection
      });
      return !!analysisConfig.EnableCustomScorecardCreationInRollouts;
    });
  }
  getEnableHypothesisVisibleInRollouts(workspaceId, managementGroup) {
    return __async(this, null, function* () {
      const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
      const analysisConfig = yield MdsDataplaneResource.getConfigWithType({
        workspaceId,
        experimentationGroup,
        section: MasterDataConstants.analysisConfigSection
      });
      return analysisConfig.EnableHypothesisVisibleInRollouts === void 0 ? true : analysisConfig.EnableHypothesisVisibleInRollouts;
    });
  }
  getAnalysisPlanInternal(rolloutRootStepId, activeOnly = true) {
    return __async(this, null, function* () {
      const address = `studyGroups?experimentStepId=${rolloutRootStepId}&activeOnly=${activeOnly}`;
      const result = yield this._get(address);
      const analysisStudyGroupDictionary = result.getSuccessData();
      const studyGroups = Object.keys(analysisStudyGroupDictionary).map(
        (key) => AnalysisUtilsInstance.convertToAnalysisGroup(analysisStudyGroupDictionary[key])
      );
      return studyGroups;
    });
  }
  removeAnalysisGroups(analysisGroups) {
    return __async(this, null, function* () {
      const groupsToRemove = _.chain(analysisGroups).filter((g) => !!g.isCommitted && !!g.isRemoved).map((g) => g.id).value();
      const promises = groupsToRemove.map((groupId) => __async(this, null, function* () {
        const address = `studyGroups/${groupId}/disable`;
        const promise = yield this._post(groupId, address);
        promise.ensureSuccess();
      }));
      yield Promise.all(promises);
    });
  }
  createNewAnalysisGroups(analysisGroups, rolloutRootStepId, workspaceId) {
    return __async(this, null, function* () {
      const address = `studyGroups`;
      const groupsToCreate = _.chain(analysisGroups).filter((g) => !g.isCommitted && !g.isRemoved).map((g) => AnalysisUtilsInstance.convertToAnalysisGroupCreateRequest(g, rolloutRootStepId, workspaceId)).value();
      const promises = groupsToCreate.map((group) => __async(this, null, function* () {
        const promise = yield this._post(group, address);
        promise.ensureSuccess();
      }));
      return yield Promise.all(promises);
    });
  }
  createNewAnalysisGroupsV2(analysisStudyGroupCreateRequest) {
    return __async(this, null, function* () {
      const address = `studyGroups`;
      return yield this._post(
        analysisStudyGroupCreateRequest,
        address
      );
    });
  }
};
AnalysisResource = __decorateClass([
  WPSProxyConverter()
], AnalysisResource);
const AnalysisResource$1 = new AnalysisResource();
export {
  AnalysisResource,
  AnalysisResource$1 as default
};
//# sourceMappingURL=AnalysisResource.js.map
